import styled, { css } from "styled-components";
import { ReactComponent as EditIcon } from "../../../assets/svgIcon/shipment/Edit.svg";
import { ReactComponent as DeleteIcon } from "../../../assets/svgIcon/shipment/DeleteOutlined.svg";

export const CrudCategory = ({
  listOfCat = [],
  btnNameForAddCat,
  handleFileCategoryModal,
  openDeleteModal,
  handleEdit,
  isBtnDisabled,
  isShowDeleteEditBtn,
  variant = "plain",
  emptyLabel,
  renderLeading,
}) => {
  const isPanel = variant === "panel";

  return (
    <CrudCategoryCss className="crudCat" $panel={isPanel}>
      <button
        type="button"
        disabled={isBtnDisabled}
        className="addBtn"
        onClick={handleFileCategoryModal}
      >
        {isPanel && (
          <svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true">
            <path
              d="M7 1.75v10.5M1.75 7h10.5"
              stroke="currentColor"
              strokeWidth="1.6"
              strokeLinecap="round"
            />
          </svg>
        )}
        {btnNameForAddCat}
      </button>

      {listOfCat.length > 0 && (
        <div className="listOfCat">
          {listOfCat.map(item => (
            <div key={item.id} className="listItem">
              {isPanel ? (
                <span className="itemName">
                  {renderLeading?.(item)}
                  <span className="itemLabel">{item?.name}</span>
                </span>
              ) : (
                item?.name
              )}
              {(item?.type?.id === "custom" ||
                item?.is_default === false ||
                isShowDeleteEditBtn) && (
                <div className="iconGroup">
                  <button
                    type="button"
                    className="iconWrapper"
                    aria-label={`Edit ${item?.name || "item"}`}
                    onClick={() => handleEdit(item, item.id)}
                  >
                    <EditIcon />
                  </button>
                  <button
                    type="button"
                    className="iconWrapper delete"
                    aria-label={`Delete ${item?.name || "item"}`}
                    onClick={() => openDeleteModal(item.id, item.name)}
                  >
                    <DeleteIcon />
                  </button>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
      {isPanel && listOfCat.length === 0 && !isBtnDisabled && emptyLabel && (
        <p className="empty">{emptyLabel}</p>
      )}
    </CrudCategoryCss>
  );
};

const panelStyles = css`
  > .addBtn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    width: 100%;
    height: 36px;
    padding: 0 12px;
    border: 1px dashed #b7c8ef;
    border-radius: 6px;
    background: #f5f8ff;
    color: #1249bf;
    font-size: 13px;
    font-weight: 600;
    line-height: 20px;
    cursor: pointer;

    &:hover:not(:disabled) {
      background: #e8f0ff;
      border-color: #2060ea;
    }

    &:disabled {
      background: #f7f8f9;
      border-color: #e5eaf0;
      color: #9aa0b4;
      cursor: not-allowed;
    }
  }

  > .listOfCat {
    gap: 6px;
    max-height: 280px;
    margin-top: 4px;
    padding-right: 2px;

    > .listItem {
      min-width: 0;
      padding: 8px 8px 8px 12px;
      border: 1px solid transparent;
      border-radius: 6px;
      background: #f7f8f9;

      &:hover {
        border-color: #e5eaf0;
        background: #f3f6fb;
      }
    }

    .itemName {
      display: flex;
      align-items: center;
      gap: 8px;
      min-width: 0;
      color: #10244d;
    }

    .itemLabel {
      min-width: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .itemLeading {
      flex: 0 0 auto;
      width: 10px;
      height: 10px;
      border-radius: 50%;
    }

    .iconGroup {
      flex: 0 0 auto;
      gap: 2px;
    }

    .iconWrapper {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 28px;
      height: 28px;
      padding: 0;
      border: none;
      border-radius: 4px;
      background: transparent;
      cursor: pointer;

      svg path {
        fill: #4a4a68;
      }

      &:hover {
        background: #fff;
      }

      &.delete:hover svg path {
        fill: #cf324a;
      }
    }
  }

  > .empty {
    margin: 2px 0 0;
    color: #676879;
    font-size: 13px;
    line-height: 20px;
  }
`;

const CrudCategoryCss = styled.div`
  > .addBtn {
    color: var(--Primary-Blue, #2060ea);
    font-weight: 400;
    line-height: 22px;
    border: none;
    background-color: #fff;
    padding-left: 0;
    &:disabled {
      color: var(--Grey, #5c5c77);
    }
  }
  > .listOfCat {
    margin-top: 12px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    font-weight: 400;
    line-height: 22px;
    color: var(--Dark-Grey, #262641);
    max-height: 25vh;
    overflow-y: auto;

    > .listItem {
      display: flex;
      justify-content: space-between;
      align-items: center;
      > .iconGroup {
        display: flex;
        align-self: self-start;
      }

      .iconWrapper {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding: 0;
        border: none;
        background: transparent;
        cursor: pointer;
      }
    }
  }

  ${props => props.$panel && panelStyles}
`;
